import { useTheme } from '@/theme';
import { Icon } from './Icon';

export function Header() {
  const [theme, toggle] = useTheme();
  return (
    <header class="header">
      <a class="header__brand" href="/">
        <img src="/img/logo.webp" alt="" width="40" height="40" />
        <span class="header__brand-text">yum</span>
      </a>
      <button
        type="button"
        class="icon-btn"
        onClick={toggle}
        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      >
        <Icon name={theme === 'light' ? 'moon' : 'sun'} />
      </button>
    </header>
  );
}
